module.exports = __webpack_public_path__ + "static/media/curriculum_theme_smartHome.14276eaf.svg";